import { Link } from "react-router-dom";

import type { PlatformDataResponse, Release } from "api/dashboardBackend";
import styles from "components/dashboard/Dashboard.module.scss";
import { getDisplayVersion } from "components/dashboard/release-card/ReleaseCardTitle";
import { getReadinessStatus } from "util/release";

interface Props {
  release: Release;
  platformData: PlatformDataResponse;
}

const ReadinessStatus = ({ release, platformData }: Props) => {
  const { imageStatus, title } = getReadinessStatus(release);
  const displayVersion = getDisplayVersion(release.majorMinor, release.patch);

  const readinessStatus = imageStatus ? (
    <>
      <div style={{ flexGrow: 1 }} />
      <Link
        className={styles.readinessLink}
        title={`${title}Click for more details.`}
        to={`/release/${encodeURIComponent(
          platformData.platform.id.toLowerCase(),
        )}/${encodeURIComponent(displayVersion.majorMinor)}`}
      >
        <img className={styles.readinessImage} src={imageStatus} />
      </Link>
    </>
  ) : null;

  return readinessStatus;
};

export default ReadinessStatus;
